import { render, staticRenderFns } from "./ProfileQuotesFacts.vue?vue&type=template&id=5082d8ad&"
import script from "./ProfileQuotesFacts.vue?vue&type=script&lang=js&"
export * from "./ProfileQuotesFacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports